import * as React from 'react';
type SvgFacebookProps = React.SVGProps<SVGSVGElement>;

const SvgFacebook = (props: SvgFacebookProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="37"
    fill="none"
    viewBox="0 0 38 37"
  >
    <rect
      width="37"
      height="37"
      x="0.5"
      fill="#fff"
      fillOpacity="0.1"
      rx="4.933"
    ></rect>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.233"
      d="M26.29 6.168h-3.669a6.1 6.1 0 0 0-4.324 1.806 6.2 6.2 0 0 0-1.792 4.36v3.7h-3.67v4.934h3.67v9.867h4.893v-9.867h3.67l1.223-4.933h-4.893v-3.7c0-.328.129-.641.358-.873.23-.23.54-.36.865-.36h3.67z"
    ></path>
  </svg>
);

export default SvgFacebook;
